export const layout = {
  layout_navTab_invite: 'دعوة',
  layout_navTab_calendar: 'التقويم',
  layout_navTab_questionnaires: 'الاستبيانات',
  layout_navTab_profile: 'الملف الشخصي',
  layout_navTab_study: 'الدراسة',
};

